module.exports = __webpack_public_path__ + "img/202506_06.e85552fe.jpg";